import { render, staticRenderFns } from "./MagazinIcon.vue?vue&type=template&id=d993f41c&scoped=true&"
import script from "./MagazinIcon.vue?vue&type=script&lang=js&"
export * from "./MagazinIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d993f41c",
  null
  
)

export default component.exports